import { render, staticRenderFns } from "./MaterialPrefix.vue?vue&type=template&id=6d99c73d&scoped=true&"
import script from "./MaterialPrefix.vue?vue&type=script&lang=js&"
export * from "./MaterialPrefix.vue?vue&type=script&lang=js&"
import style0 from "./MaterialPrefix.vue?vue&type=style&index=0&id=6d99c73d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d99c73d",
  null
  
)

export default component.exports